// @ts-nocheck
import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { TrailerCollectionModel } from "@insite/client-framework/Types/ApiModels";

export interface GetTrailersApiParameter extends ApiParameter, HasPagingParameters {
    shipToBp?: string;
    trailerIdentification?: string;
    dwellTimeInDays?: string | number;
    dwellTimeInDaysOperator?: string | number;
    trailerItem?: string;
    trailerGreifPlant?: string;
    trailerCustomerOrder?: string;
    trailerItemDescription?: string;
}

const trailerUrl = "/api/v1/custom/droptrailer";

export async function getTrailers(parameter: GetTrailersApiParameter): Promise<TrailerCollectionModel> {
    delete (parameter as any).onComplete;
    const trailers = await get<TrailerCollectionModel>(trailerUrl, parameter);

    return trailers;
}
